import { getCurrentUser } from '@lognai/plugin-sdk';

/** The backend gates the privileged path (edit/close/delete any task) on this grant. */
export const TASK_MANAGE_ALL = 'tasks:task:manage:all';

export const hasTaskManageAll = (permissions?: string[]): boolean => {
  const granted = permissions ?? getCurrentUser()?.permissions ?? [];
  return granted.includes('*') || granted.includes(TASK_MANAGE_ALL);
};

/**
 * Gates the assignee picker and the "Assign to X" chip. Hiding them is a courtesy,
 * not the boundary — the backend enforces this on every assignment.
 */
export const TASK_ASSIGN = 'tasks:task:assign';

export const hasTaskAssign = (permissions?: string[]): boolean => {
  const granted = permissions ?? getCurrentUser()?.permissions ?? [];
  return granted.includes('*') || granted.includes(TASK_ASSIGN);
};

/** The backend requires this to create a task from an entity rail. */
export const TASK_CREATE = 'tasks:task:create';

export const hasTaskCreate = (permissions?: string[]): boolean => {
  const granted = permissions ?? getCurrentUser()?.permissions ?? [];
  return granted.includes('*') || granted.includes(TASK_CREATE);
};
